import { defineComponent as _defineComponent } from 'vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { fetchStudioStudents, deleteStudioStudentById, addStudioStudent } from '@/enitites/studio/api/endpoints'
import { ref, watch } from 'vue'
import UserChip from '@/shared/ui/chips/UserChip.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { mdiMagnify, mdiMinusCircleOutline, mdiPlus } from '@mdi/js'
import { BKModal } from '@/shared/ui/modals'
import BKUserSelect from '@/components/BKUserSelect.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsStudents',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as { studio: Studio };



const totalStudentsCount = ref(props.studio.totalStudents || 0)
const studioStudents = ref<StudioUser[]>([])
const infiniteId = ref(Number(new Date()))
const loading = ref(false)
const showNotFound = ref(false)
const searchParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
  keyword: '',
  sortBy: 'name',
  sortDir: 'asc',
})

const infiniteHandler = async ($state: { complete: () => void; loaded: () => void }) => {
  loading.value = true
  const data = await fetchStudioStudents(props.studio.id, searchParams.value)
  loading.value = false

  if (!Array.isArray(data)) {
    $state.complete()
    return
  }
  searchParams.value.pageNumber += 1

  studioStudents.value = [...studioStudents.value, ...data]
  if (!studioStudents.value.length) showNotFound.value = true
  if (data.length < searchParams.value.pageSize) $state.complete()
  else $state.loaded()
}

const searchTimeout = ref<number | null>(null)

const showAddModal = ref(false)
const isAddingStudent = ref(false)
const newlyAddedStudents = ref<StudioUser[]>([])

const handleAddUser = async (user: StudioUser) => {
  isAddingStudent.value = true

  try {
    const res = await addStudioStudent(props.studio.id, user.id)
    if (!res) return

    studioStudents.value.push(user)
    newlyAddedStudents.value.push(user)
    totalStudentsCount.value += 1
  } catch (e) {
    Bugsnag.notify(e instanceof Error ? e : new Error(String(e)), (event) => {
      event.addMetadata('studio', {
        context: 'Error adding studio student',
        studioId: props.studio.id,
        userId: user.id,
      })
    })
  } finally {
    isAddingStudent.value = false
  }
}

const handleDeleteUser = async (user: StudioUser) => {
  const res = await deleteStudioStudentById(props.studio.id, user.id)
  if (res !== 'ok') return

  studioStudents.value = studioStudents.value.filter((u) => u.id !== user.id)
  newlyAddedStudents.value = newlyAddedStudents.value.filter((u) => u.id !== user.id)
  totalStudentsCount.value -= 1
}

watch(
  () => searchParams.value.keyword,
  () => {
    if (searchTimeout.value) clearTimeout(searchTimeout.value)
    searchTimeout.value = setTimeout(() => {
      searchParams.value.pageNumber = 0
      studioStudents.value = []
      showNotFound.value = false
      infiniteId.value += 1
      searchTimeout.value = null
    }, 600)
  }
)

return { __sfc: true,props, totalStudentsCount, studioStudents, infiniteId, loading, showNotFound, searchParams, infiniteHandler, searchTimeout, showAddModal, isAddingStudent, newlyAddedStudents, handleAddUser, handleDeleteUser, UserChip, BKInput, mdiMagnify, mdiMinusCircleOutline, mdiPlus, BKModal, BKUserSelect }
}

})